import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';

@Component({
  selector: 'dojo-app-logo',
  standalone: true,
  template: `
    <div class="logo-container">
      <div class="logo-compact-wrapper" [class.visible]="compact()">
        <img [src]="state.darkMode ? iconSrcDark() ?? iconSrc() : iconSrc()" [alt]="alt()" [class]="iconClass()" />
      </div>
      <div class="logo-full-wrapper" [class.visible]="!compact()">
        <img
          [src]="state.darkMode ? logoSrcDark() ?? logoSrc() : logoSrc()"
          [alt]="alt()"
          [class]="logoSecondClass()"
        />
      </div>
    </div>
  `,
  styleUrl: './app-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-[44px] w-full min-w-0 items-center' },
})
export class AppLogoComponent {
  constructor(private readonly colorSchemeService: ColorSchemeService) {}

  readonly iconSrc = input.required<string>();
  readonly iconSrcDark = input<string>();
  readonly logoSrc = input.required<string>();
  readonly logoSrcDark = input<string>();
  readonly alt = input<string>('ExamDojo');
  readonly iconClass = input<string>('w-[44px]');
  readonly logoSecondClass = input<string>('w-[111px]');
  readonly compact = input<boolean>(false);

  readonly state = connectState({
    darkMode: this.colorSchemeService.hasDarkMode$,
  });
}
